import React from 'react';
import PropTypes from 'prop-types';
import SearchIcon from '../../../search/icons/icon-search.svg';
import Link from '../../../shared/components/Link/Link';


const SearchForm = function SearchFormComponent({
  formRef,
  placeholder,
  handleQueryChange,
  handleQuerySubmit,
  toggleSuggestions,
  showSuggestions,
  suggestions,
}) {
  return (
    <form
      ref={formRef}
      method="GET"
      role="search"
      onSubmit={handleQuerySubmit}
      className="search-form"
      onFocus={() => toggleSuggestions(true)}
      onBlur={() => toggleSuggestions(false)}
    >
      <label htmlFor="search-input" className="search-form__label">
        <span className="search-form__label-text">Search site</span>
        <SearchIcon className="search-form__icon" />
        <input
          id="search-input"
          className="search-form__input"
          type="search"
          name="search"
          autoComplete="off"
          onChange={handleQueryChange}
          placeholder={placeholder}
        />
      </label>
      {showSuggestions && suggestions.length > 0 && (
        <div className="search-form__dropdown">
          {suggestions.map(({ name, url }) => (<Link href={url} key={url} className="search-form__suggestion">{name}</Link>))}
        </div>
      )}
    </form>
  );
};

SearchForm.propTypes = {
  placeholder: PropTypes.string.isRequired,
  showSuggestions: PropTypes.bool.isRequired,
  suggestions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  formRef: PropTypes.shape({}).isRequired,
  handleQueryChange: PropTypes.func.isRequired,
  handleQuerySubmit: PropTypes.func.isRequired,
  toggleSuggestions: PropTypes.func.isRequired,
};

export default SearchForm;
